import { DraftCreateActionSelectModal } from '../../Draft'

function RequestDraftCreateActionSelectModal(props) {
  return (
    <DraftCreateActionSelectModal
      {...props}
      createNewLabelKey='Request.CreateNewKey'
      formFieldsProps={{ titleKey: 'Request.CreateModalActionTitleKey' }}
      openDraftLabelKey='Request.OpenDraftKey'
      submitTextKey='Modal.CreateBtnKey'
      titleKey='Request.CreateModalTitleKey'
    />
  )
}

export default RequestDraftCreateActionSelectModal
